<template>
  <div class="layers-side-menu">
    <div class="left-align left">
      <span class="heading">Layers</span>
    </div>
    <div class="vspace"></div>
    <div id="layers">
      <div class="left-align left right layer-item" 
      v-for="item in allObjects" v-bind:key="item.id" draggable="true" @click="select(item.id)"
      :style="isSelected(item.id) ? { 'background-color': 'whitesmoke' } : {} ">
        <i class="icon icon-eye clickable right" ></i>
        <div class="inline typebg">
          <div>{{getTypeSymbol(item.TYPE)}}</div>
        </div>
        <div class="inline">
          <div>{{item.name}}</div>
        </div>
        <div class="inline float options">
          <i class="icon icon-chevron-up clickable left" @click="moveUp(item.id, $event)"></i>
          <i class="icon icon-chevron-down clickable left" @click="moveDown(item.id, $event)"></i>
          <i class="icon icon-trash clickable left" @click="deleteObj(item.id, $event)"></i>
        </div>
      </div>

      <div v-if="allObjects.length==0"  class="left right" style="margin-top:70%; color:gray">
        Add a shape/text/image to canvas
        <br/>or
        <br/>Select an object on canvas by clicking on it.
      </div>
    </div>
  </div>
</template>

<script>
import { ObjectType } from '../../lib/bezieLib/Objects/ObjectTypeEnum';
import { BObject } from '../../lib/bezieLib/Objects/BObject';
import { Scene } from '../../lib/bezieLib/Scene';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import { BezieApp } from '../../lib/bezieLib/BezieApp';
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';

export default {
  name: 'LayersSideMenu',
  props: {
    bezieAppObj : BezieApp
  },
  data: function(){
    return {
      selectedObject: null,
      allObjects: [],
      layeritems: [
            {
              'name':'Unnamed-Object 1',
              'type':'I'
            },
            {
              'name':'Unnamed-Object 2',
              'type':'V'
            },
            {
              'name':'Unnamed-Object 3',
              'type':'T'
            },
            {
              'name':'Unnamed-Object 4',
              'type':'I'
            }]
    }
  },
  methods: {
    isSelected(id){
      return this.selectedObject!=null && id == this.selectedObject.getId();
    },
    select(id){
      if(this.bezieAppObj.getScene()){
        this.bezieAppObj.getScene().selectObjectById(id);
        this.init();
      }
    },
    moveDown(id, event){
      if (event) {
        event.stopPropagation()
      }
      if(this.bezieAppObj.getScene()){
        this.bezieAppObj.getScene().moveObjectALayerById(false, id);
      }
    },
    moveUp(id, event){
      if (event) {
        event.stopPropagation()
      }
      if(this.bezieAppObj.getScene()){
        this.bezieAppObj.getScene().moveObjectALayerById(true, id);
      }
    },
    deleteObj(id, event){
      if (event) {
        event.stopPropagation()
      }
      if(this.bezieAppObj.getScene()){
        this.bezieAppObj.getScene().deleteObjectById(id);
      }
    },
    getTypeSymbol: function(type){
      var symbol = "U";
      switch(type){
        case ObjectType.IMAGE:
            symbol = "I";
          break;

        case ObjectType.TEXT:
            symbol = "T";
          break;

        case ObjectType.CIRCLE:
            symbol = "C";
          break;

        case ObjectType.RECT:
            symbol = "R";
          break;

        case ObjectType.VECTOR:
            symbol = "V";
          break;

        case ObjectType.GROUP:
            symbol = "G";
          break;

        case ObjectType.SOURCE:
            symbol = "S";
          break;
      }
      return symbol;
    },
    init: function(){
      this.selectedObject = this.bezieAppObj.getScene().getSelectedObject();
      this.allObjects = this.bezieAppObj.getScene().getAllObjects();
    },
    onUpdate : function(obj, holdsMultipleSelectedItems){
      console.log("on selection change - update called layers");
      if(obj){
        this.init();
      } else {
        this.selectedObject = null;
      }
    }
  },
  mounted: function(){
    if(this.bezieAppObj){  
      UIUpdate.addSelectionChangeListener(this);  
      this.init();
    }
  },
  beforeDestroy: function(){
    UIUpdate.removeSelectionChangeListener(this);
  }
}
</script>

<style scoped>

.layer-item{
  margin: 10px;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #ededed;
}
.layer-item:hover {
  background-color: whitesmoke;
}

.options:hover{
  cursor: pointer;
}

.float{
  float: right;
}

.typebg{
  background-color: grey;
  color: white;
  width: 20px;
  height: 20px;
  text-align: center;
  margin-right: 10px;
}

</style>